'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Notification = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _glamorous = require('glamorous');

var _glamorous2 = _interopRequireDefault(_glamorous);

var _shortid = require('shortid');

var _shortid2 = _interopRequireDefault(_shortid);

var _recompose = require('recompose');

var _reactTransitionGroup = require('react-transition-group');

var _Notification = require('./Notification.style');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var scrollToElement = void 0;

var addScrollOnClient = (0, _recompose.lifecycle)({
  componentDidMount: function componentDidMount() {
    scrollToElement = require('scroll-to-element');
  }
});

/**
 *  Generic notification component. Used as the base for other notification.
 *  You will most likely never use this component directly because
 *  it is mostly unstyled.
 *  TODO: Add some styles to the base Notification Component Please!
 */
var Notification = exports.Notification = function Notification(_ref) {
  var className = _ref.className,
      handleClose = _ref.handleClose,
      messages = _ref.messages,
      scrollClick = _ref.scrollClick,
      show = _ref.show;
  return _react2.default.createElement(
    'div',
    { className: className },
    _react2.default.createElement(
      _reactTransitionGroup.TransitionGroup,
      null,
      show && messages && messages.length > 0 && _react2.default.createElement(
        _reactTransitionGroup.CSSTransition,
        {
          timeout: 200,
          classNames: 'vertical-slide' },
        _react2.default.createElement(
          'div',
          { className: 'notification', key: _shortid2.default.generate() },
          _react2.default.createElement('i', { onClick: handleClose, className: 'fa fa-2x fa-close' }),
          messages.map(function (message) {
            return _react2.default.createElement(
              'div',
              {
                key: _shortid2.default.generate(),
                className: 'message',
                onClick: scrollClick ? function () {
                  return scrollToElement('#' + message.id, {
                    offset: 0,
                    ease: 'inSine',
                    duration: 250
                  });
                } : null
              },
              _react2.default.createElement(
                'div',
                { className: 'title' },
                message.title
              ),
              _react2.default.createElement(
                'div',
                { className: 'text' },
                message.text
              )
            );
          })
        )
      )
    )
  );
};

Notification.propTypes = {
  /**
  * This property is required to apply glamorous styles to the component.
  * It is not necessary to add a className, but it will be merged with the
  * glamorous className if you do.
  */
  className: _propTypes2.default.string.isRequired,
  /**
   * Function called when X is clicked
   */
  handleClose: _propTypes2.default.func.isRequired,
  /**
   * Messages to display under title
   */
  messages: _propTypes2.default.array,
  /**
   * Whether the notification is visible
   */
  show: _propTypes2.default.bool.isRequired,
  /**
   * Whether the scrollTo is active in detailed
   * notifications, to scroll to the error in a form
   * (see ErrorNotification)
   */
  scrollClick: _propTypes2.default.bool

};

exports.default = addScrollOnClient((0, _glamorous2.default)(Notification)(_Notification.defaultStyle, _Notification.mapPropsAndThemeToStyle));


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nike/ruxac/components/notifications/Notification/Notification.js
// module id = 137
// module chunks = 0